import { useCallback, useState } from "react";

const STORAGE_KEY = "proofly.ocr.autoFill.v1";

function readPreference(): boolean {
  if (typeof window === "undefined") return true;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return true; // default ON
    return raw === "true";
  } catch {
    return true;
  }
}

function writePreference(value: boolean): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    /* ignore */
  }
}

export function useOcrPreference(): {
  autoFill: boolean;
  setAutoFill: (value: boolean) => void;
} {
  const [autoFill, setAutoFillState] = useState<boolean>(readPreference);

  const setAutoFill = useCallback((value: boolean) => {
    setAutoFillState(value);
    writePreference(value);
  }, []);

  return { autoFill, setAutoFill };
}
